<template>
    <div v-if="visible"
      class="alert alert-danger align-items-center text-center" role="alert">
      <div class="col-md-12 p-2">{{t('No records found')}}</div>
    </div>
</template>

<script setup>
import { ref, defineExpose } from 'vue';
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const visible = ref(false)

defineExpose({
  visible,
});

</script>

<i18n>
  {
    "pl": {
      "No records found": "Nie znaleziono danych",
    }
  }
</i18n>
